import { render, staticRenderFns } from "./SpendingLogTable.vue?vue&type=template&id=119b08b9"
import script from "./SpendingLogTable.vue?vue&type=script&lang=js"
export * from "./SpendingLogTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports